import Home from './home';
import Offers from './offers';
import Committee from './committee';
import CommitteeAll from './committee-all';
import EditProfile from './edit-profile';
import UserProfile from './user-profile';
import EditUser from './edit-user';
import Resources from './resources';
import ResourcesManagement from './resource-management';
import AddUser from './add-user';
import UserList from './user-list';
import StaticPages from './set-static-pages';
import NewDetectionForm from './new-detection-form';
import ArticleEditForm from './edit-detection-form';
import LogsAll from './logs-all';
import AuthorList from './author-list';
import AuthorAdd from './author-add';
import AuthorEdit from './author-edit';
import AuthorArticles from './author-articles';
import FileManagment from './file-managment';
import AddNewArticle from './add-new-article';
import AskCommiteeDecision from './ask-comitte-decision';
import AskOpinion from './ask-opinion';
import GiveDecision from './give-decision';
import SupervisorSendItems from './supervisor-send-item';
import TranslationSendItems from './translation-send-item';
import ArticleDetailProvider from './article-detail/ArticleDetailContext';
import ArticleDetail from './article-detail';
import AfterCopyrightGiveDescision from './after-copyright-give-descision';
import AfterCopyrightSupervisorControlView from './after-copyright-give-descision/AfterCopyrightSupervisorControlView';
import ArticleRelationManagement from './article-relation-management/list';
import ArticleRelationManagementEdit from './article-relation-management/edit';
import ArticleGroupManagement from './article-group-management';

// situation alanı hangi rollerin bu route a erişebileceğini belirtir.
export const allRoutes = [
  {
    path: '/anasayfa',
    component: <Home />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/tum-maddeler',
    component: <Offers />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/tum-maddeler/telif-sonrasi',
    component: <Offers />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/ansiklopedi-birimi/bana-atananlar',
    component: <Offers />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/ansiklopedi-birimi/kontrol-edilecekler',
    component: <Offers />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/yayin-mudurlugu/bana-atananlar',
    component: <Offers />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/yayin-mudurlugu/kontrol-edilecekler',
    component: <Offers />,
    situation: ['all'],
  },
  {
    path: '/madde-detay/:id',
    component: (
      <ArticleDetailProvider>
        <ArticleDetail />
      </ArticleDetailProvider>
    ),
    situation: ['all'],
  },
  {
    path: '/heyetler/heyet-detay/:id',
    component: <Committee />,
    situation: ['all'],
  },
  {
    path: '/heyetler/ilim-heyetleri',
    component: <CommitteeAll />,
    situation: ['all'],
  },
  {
    path: '/profil-duzenle',
    component: <EditProfile />,
    situation: ['all'],
  },
  {
    path: '/kullanici-bilgileri',
    component: <UserProfile />,
    situation: ['all'],
  },
  {
    path: '/uye-islemleri/uye-duzenle/:id',
    component: <EditUser />,
    situation: ['admin'],
  },
  {
    path: '/e-kaynaklar',
    component: <Resources />,
    situation: ['all'],
  },
  {
    path: '/e-kaynak/ekle',
    component: <ResourcesManagement />,
    situation: ['resourcesManager'],
  },
  {
    path: '/e-kaynak/duzenle/:id',
    component: <ResourcesManagement />,
    situation: ['resourcesManager'],
  },
  {
    path: '/uye-islemleri/uye-ekle',
    component: <AddUser />,
    situation: ['admin'],
  },
  {
    path: '/uye-islemleri/uye-listesi',
    component: <UserList />,
    situation: ['admin'],
  },
  {
    path: '/madde-teklifleri/:id/teklif-edilen-maddeler',
    component: <Offers />,
    situation: ['admin'],
  },
  {
    path: '/yeni-icerik-ekle/:id',
    component: <AddNewArticle />,
    situation: ['all'],
  },
  {
    /**
     * Yabancı yazara sistemden bilgilendirme gitmediği için madde dosyasını sorumlu ilim heyetinin
     * başkanı ya da sekreteri yazar adına yükleyip gönderir. Ekran yazarınkiyle aynıdır; yetki
     * kontrolünü sayfanın kendisi yapar.
     */
    path: '/yazar-adina-madde-gonder/:id',
    component: <AddNewArticle onBehalfOfAuthor />,
    situation: ['all'],
  },
  {
    /**
     * Yabancı dildeki maddenin Türkçe tercümesini sorumlu ilim heyetinin başkanı ya da sekreteri
     * yükleyip gönderir; madde İH - Madde Kontrol aşamasına döner. Yetki kontrolünü sayfa kendisi yapar.
     */
    path: '/tercume-yukle/:id',
    component: <TranslationSendItems />,
    situation: ['all'],
  },
  {
    path: '/sorumlu-madde-gonder/:id',
    component: <SupervisorSendItems />,
    situation: ['all'],
  },
  {
    path: '/ilim-heyetinden-oneri-iste/:id',
    component: <AskCommiteeDecision />,
    situation: ['all'],
  },

  {
    path: '/heyet-karar/:step/:offerID/:comitteeID/:status',
    component: <AskOpinion />,
    situation: ['all'],
  },
  {
    path: '/heyet-karar/:step/:offerID/:status',
    component: <GiveDecision />,
    situation: ['all'],
  },
  {
    path: '/madde-iliskilendirme-yonetimi',
    component: <ArticleRelationManagement />,
    situation: ['all'],
  },
  {
    path: '/madde-iliskilendirme-yonetimi/duzenle/:uid',
    component: <ArticleRelationManagementEdit />,
    situation: ['all'],
  },
  {
    path: '/madde-grup-yonetimi',
    component: <ArticleGroupManagement />,
    situation: ['all'],
  },
  {
    path: '/telif-sonrasi/heyet-karar/:step/:committee/:offerID/:status',
    component: <AfterCopyrightGiveDescision />,
    situation: ['all'],
  },
  {
    path: '/telif-sonrasi/madde-sorumlusu-karar/:step/:committee/:offerID/:status',
    component: <AfterCopyrightSupervisorControlView />,
    situation: ['all'],
  },
  {
    path: '/madde-teklifleri/:id/heyetten-cikan-maddeler',
    component: <Offers />,
    situation: ['admin'],
  },
  {
    path: '/maddelerim',
    component: <AuthorArticles />,
    situation: ['admin', 'author'],
  },
  {
    path: '/sabit-sayfalar',
    component: <StaticPages />,
    situation: ['admin'],
  },
  {
    path: '/madde-teklifleri/:id/sorumlu-olunan-maddeler',
    component: <Offers />,
    situation: ['admin'],
  },
  {
    path: '/madde-teklifleri/:id/gorus-istenen-maddeler',
    component: <Offers />,
    situation: ['admin'],
  },
  {
    path: '/madde-teklifleri/:id/taslak-maddeler',
    component: <Offers />,
    situation: ['admin'],
  },
  {
    path: '/yeni-madde-teklifi/madde-tespit-formu',
    component: <NewDetectionForm />,
    situation: ['admin', 'canOffer'],
  },
  {
    path: '/madde-teklifleri/:id',
    component: <Offers />,
    situation: ['admin'],
  },
  {
    path: '/sorumlu-olduklarim',
    component: <Offers />,
    situation: ['all'],
  },

  {
    path: '/madde-tespit-formu/duzenle/:id',
    component: <ArticleEditForm />,
    situation: ['admin', 'executive'],
  },
  {
    path: '/loglar/tum-loglar',
    component: <LogsAll />,
    situation: ['executive'],
  },
  {
    path: '/yazar-islemleri/yazar-listesi',
    component: <AuthorList />,
    situation: ['all'],
  },
  {
    path: '/yazar-islemleri/yazar-ekle',
    component: <AuthorAdd />,
    situation: ['admin', 'executive'],
  },
  {
    path: '/yazar-islemleri/yazar-duzenle/:id',
    component: <AuthorEdit />,
    situation: ['all'],
  },
  {
    path: '/dosya-yonetimi',
    component: <FileManagment />,
    situation: ['admin'],
  },
];
